import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Button, LinkButton} from '@components/common/base/buttons'
import {cn} from '@containers/html-utils'
import {useLoginStore} from './login-store'

export const LoginRecovery = observer(() => {
  const [state, store] = useLoginStore()

  return (
    <div className="login-forget forget">
      {!state.forgetShow && (
        <div className="_link" onClick={() => store.setForgetShow(true)}>
          {Lang.msg.forgotAcc}
        </div>
      )}

      <div className={cn('loading', !state.forgetWait && 'hidden')} />

      {state.forgetShow && !state.forgetWait && (
        <div className="login-forget-form">
          <div className="login-forget-title">{Lang.msg.resetPass}</div>
          <label className="login-forget-field">
            <span className="login-forget-label">{Lang.msg.yourEmail}</span>
            <input
              type="email"
              className="login-forget-input"
              autoFocus
              placeholder={Lang.msg.emailPlaceholder}
              value={state.forgetEmail}
              onChange={store.setForgetEmail}
              disabled={state.forgetWait}
              onKeyDown={store.forgetKeyDown}
            />
          </label>
          <Button className="m-auto" onClick={store.forgetSubmit} size="small">
            {Lang.msg.resetPass2}
          </Button>
          <LinkButton
            className="m-auto"
            onClick={() => store.setForgetShow(false)}
            size="small"
          >
            {Lang.msg.close}
          </LinkButton>
          {!!state.forgetError && (
            <div className="login-forget-error">
              <i className="fi-alert" />
              <span>{state.forgetError}</span>
            </div>
          )}

          {!!state.forgetSuccess && (
            <div className="login-forget-success">
              <i className="fi-check" /> {Lang.msg.resetPassSent}
            </div>
          )}
        </div>
      )}
    </div>
  )
})
